import React from "react";

import { StyledRadio } from "./radio.style";

const Radio = ({
  register,
  value,
  name,
  required,
  readOnly,
  label,
  disabled,
  shouldUnregister = false,
  ...rest
}) => {
  const withRegister = () => {
    if (!register) return null;

    const { onChange, onBlur, ref } = register(name, {
      required: {
        value: required,
        message: "This field is required",
      },
      value: value,
      disabled: disabled,
      shouldUnregister: shouldUnregister,
    });

    return {
      onChange,
      name,
      onBlur,
      ref,
    };
  };

  return (
    <StyledRadio>
      <input
        type="radio"
        value={value}
        {...withRegister()}
        disabled={readOnly || disabled}
        {...rest}
      />
      <span className="text">{label || value}</span>
      <span className="checkmark"></span>
    </StyledRadio>
  );
};

export default Radio;
